import React from "react";
import Stripe, { StripeProps } from "./Stripe";
import HyperSwitch, { HyperSwitchProps } from "./HyperSwitch";
import { PaymentProvider } from "../hooks/usePayment";

export type CheckoutFormProps = HyperSwitchProps &
  StripeProps & {
    paymentProvider?: String;
    secret?: string;
    paymentProcessorPubKey?: string;
  };

const CheckoutForm: React.FC<CheckoutFormProps> = ({
  secret,
  onSuccess,
  hideSubmit = false,
  submitLoading,
  backendPaymentFailureError,
  paymentProvider,
  paymentProcessorPubKey,
}) => {
  if (!secret) return null;

  if (paymentProvider === PaymentProvider.NARVAR) {
    // if (!paymentProcessorPubKey) return null;
    return (
      <HyperSwitch
        secret={secret}
        paymentProcessorPubKey={paymentProcessorPubKey}
        backendPaymentFailureError={backendPaymentFailureError}
      />
    );
  }

  return (
    <Stripe
      secret={secret}
      onSuccess={onSuccess}
      hideSubmit={hideSubmit}
      submitLoading={submitLoading}
      backendPaymentFailureError={backendPaymentFailureError}
    />
  );
};

export default CheckoutForm;
